import React, { useState, useEffect } from "react";
import { Routes, Route, HashRouter, Navigate } from "react-router-dom";
import axios from "axios";

// Page Components
import Dashboard from "./pages/Dashboard";
import Sidebar from "./layout/Sidebar";
import Login from "./pages/Login";
import Investor from "./pages/Investor";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import CollectionAgent from "./pages/CollectionAgent";
import Customers from "./pages/Customers";
import AssignAccount from "./pages/AssignAccount";
import SchemeCreation from "./pages/SchemeCreation";
import Loan from "./pages/Loan";
import LoanCollection from "./pages/LoanCollection";
import ReportPage from "./pages/ReportPage";
import TodayCollection from "./pages/TodayCollection";
import AdminCollection from "./pages/AdminCollection";
import CustomersPage from "./pages/CustomersPage";
import CollectionsPage from "./pages/CollectionsPage";
import NewCustomersPage from "./pages/NewCustomersPage";
import CustomerDetailsPage from "./pages/CustomerDetailsPage";
import InitialProfitPage from "./pages/InitialProfitPage";
import LoanCustomersPage from "./pages/LoanCustomersPage";
import DailyLoanCustomers from "./pages/DailyLoanCustomers";
import WeeklyLoanCustomers from "./pages/WeeklyLoanCustomers";
import NewLoansReport from "./pages/NewLoansReport";
import DailyLoanToPayPage from "./pages/DailyLoanToPayPage";
import WeeklyLoanToPayPage from "./pages/WeeklyLoanToPayPage";
import FinanceDashBoard from "./pages/FinanceDashBoard";
import InvestmentPage from "./pages/InvestmentPage";
import Logout from "./pages/Logout";
import Setup from "./pages/Setup";
import AgentLogin from "./pages/AgentLogin";
import AgentDashboard from "./pages/AgentDashboard";
import MyProfile from "./pages/MyProfilePage";
import AttendancePage from "./pages/Attendance";
import AgentAttendanceReportPage from "./pages/AgentAttendanceReportPage";
import AdvancePage from "./pages/AdvancePage";
import AgentAdvanceReportPage from "./pages/AgentAdvanceReport";

function App() {
  const [isSetupCompleted, setIsSetupCompleted] = useState(null);
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const checkSetupStatus = async () => {
      try {
        const response = await axios.get(`${baseURL}/check-setup`);
        setIsSetupCompleted(response.data.isSetupCompleted);
      } catch (error) {
        console.error("Error checking setup status:", error);
        setIsSetupCompleted(false);
      }
    };

    checkSetupStatus();
  }, []);

  if (isSetupCompleted === null) {
    return <div>Loading...</div>;
  }

  return (
    <HashRouter>
      <Routes>
        {isSetupCompleted ? (
          <>
            <Route path="/" element={<Login />} />
            <Route
              path="/Dashboard"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <Dashboard />
                </>
              }
            />
            <Route
              path="/Investor"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <Investor />
                  <Footer />
                </>
              }
            />
            <Route
              path="/CollectionAgent"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <CollectionAgent />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Customers"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <Customers />
                  <Footer />
                </>
              }
            />
            <Route
              path="/AssignAccount"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <AssignAccount />
                  <Footer />
                </>
              }
            />
            <Route
              path="/SchemeCreation"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <SchemeCreation />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Loan"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <Loan />
                  <Footer />
                </>
              }
            />
            <Route
              path="/LoanCollection"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <LoanCollection />
                  <Footer />
                </>
              }
            />
            <Route
              path="/ReportPage"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <ReportPage />
                  <Footer />
                </>
              }
            />
            <Route
              path="/Attendance"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <AttendancePage />
                  <Footer />
                </>
              }
            />
            <Route path="/TodayCollection" element={<TodayCollection />} />
            <Route path="/AdminCollection" element={<AdminCollection />} />
            <Route path="/CustomersPage" element={<CustomersPage />} />
            <Route path="/CollectionsPage" element={<CollectionsPage />} />
            <Route path="/NewCustomersPage" element={<NewCustomersPage />} />
            <Route
              path="/CustomerDetailsPage"
              element={<CustomerDetailsPage />}
            />
            <Route path="/InitialProfitPage" element={<InitialProfitPage />} />
            <Route path="/LoanCustomersPage" element={<LoanCustomersPage />} />
            <Route
              path="/DailyLoanCustomers"
              element={<DailyLoanCustomers />}
            />
            <Route
              path="/WeeklyLoanCustomers"
              element={<WeeklyLoanCustomers />}
            />
            <Route path="/NewLoansReport" element={<NewLoansReport />} />
            <Route
              path="/DailyLoanToPayPage"
              element={<DailyLoanToPayPage />}
            />
            <Route
              path="/WeeklyLoanToPayPage"
              element={<WeeklyLoanToPayPage />}
            />
            <Route path="/FinanceDashBoard" element={<FinanceDashBoard />} />
            <Route path="/InvestmentPage" element={<InvestmentPage />} />
            <Route path="/Logout" element={<Logout />} />
            <Route path="/agent-login" element={<AgentLogin />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/AgentDashboard" element={<AgentDashboard />} />
            <Route path="/myprofile" element={<MyProfile />} />
            <Route
              path="/Advance"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <AdvancePage />
                  <Footer />
                </>
              }
            />
            <Route
              path="/AgentAttendanceReport"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <AgentAttendanceReportPage />
                  <Footer />
                </>
              }
            />

            <Route
              path="/AgentAdvanceReport"
              element={
                <>
                  <Sidebar />
                  <Header />
                  <AgentAdvanceReportPage />
                  <Footer />
                </>
              }
            />
          </>
        ) : (
          <>
            <Route
              path="/"
              element={<Setup onComplete={() => setIsSetupCompleted(true)} />}
            />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </HashRouter>
  );
}

export default App;
